import { LocalActivity } from "@mui/icons-material";
import { HighlightCard } from "./Highlights";

export const EntriesOpen = ({ event }) => (
    <HighlightCard
        backgroundColor={theme => theme.palette.highlights.entry_open}
        text="Entry open"
        icon={<LocalActivity fontSize="inherit" />}
        name={event.name}
        to={`/events/${event.id}`}
    />
);
